

const AuzCallBack = () => {
    return <>
        <p>call back</p>
    </>
}
export default AuzCallBack